import { render, staticRenderFns } from "./EntityNestedReationshipDataTable.vue?vue&type=template&id=0422cb52&scoped=true"
import script from "./EntityNestedReationshipDataTable.vue?vue&type=script&lang=js"
export * from "./EntityNestedReationshipDataTable.vue?vue&type=script&lang=js"
import style0 from "./EntityNestedReationshipDataTable.vue?vue&type=style&index=0&id=0422cb52&prod&lang=scss&scoped=true"
import style1 from "./EntityNestedReationshipDataTable.vue?vue&type=style&index=1&id=0422cb52&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0422cb52",
  null
  
)

export default component.exports